import { useModuleGate } from '../../../lib/moduleGate';

/**
 * True when Agents as Users (Voices) should be accessible.
 *
 * Canonical gate (build contract §2.7): agents_as_users workspace module +
 * policy userDefault, with the user's agents_as_users flag as the personal
 * override when the policy allows it. Default module off; Backspace enabled
 * via migration 567.
 */
export function useAgentsAsUsersEnabled(): boolean {
  return useModuleGate('agents_as_users');
}
